import { Link } from "react-router-dom";

export default function LinkButton(props){
  return(
    <a href={props.to} target="_blank" className="LinkButton" style={props.style}>
      <div className="Icon">
        <img className="imgIcon Static" src={props.icon.static} alt={`icon ${props.title}`} />
        <img className="imgIcon Hover" src={props.icon.hover} alt={`icon ${props.title}`} />
      </div>
      
      <span className="Text">
        {props.title}
      </span>
    </a>
  )
}